import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSettings } from "../../context/SettingsContext";

const KEY = "hh_cookie_consent";

const loadGA = (id) => {
  if (!id || window.__hh_ga) return;
  window.__hh_ga = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id, { anonymize_ip: true });
};

export const CookieBanner = () => {
  const { ga4_id } = useSettings();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) setVisible(true);
    if (v === "accepted") loadGA(ga4_id);
    const open = () => setVisible(true);
    window.addEventListener("hh-open-cookie-prefs", open);
    return () => window.removeEventListener("hh-open-cookie-prefs", open);
  }, [ga4_id]);

  const decide = (v) => {
    localStorage.setItem(KEY, v);
    localStorage.setItem(`${KEY}_at`, new Date().toISOString());
    setVisible(false);
    if (v === "accepted") loadGA(ga4_id);
    else if (window.__hh_ga) window.location.reload();
  };

  if (!visible) return null;
  return (
    <div data-testid="cookie-banner" role="dialog" aria-label="Preferenze cookie" className="fixed z-[60] bottom-20 md:bottom-6 left-4 right-4 md:left-6 md:right-auto md:max-w-md bg-ink text-cream p-6 md:p-7 shadow-2xl border border-white/10">
      <div className="eyebrow mb-3">Cookie</div>
      <p className="text-sm font-light text-cream/80 leading-relaxed">
        Questo sito utilizza cookie tecnici, necessari al funzionamento, e — solo con il tuo consenso — cookie statistici di terze parti (Google Analytics).
        Chiudendo con "Solo necessari" prosegui senza cookie non tecnici. Puoi modificare la scelta in ogni momento da "Preferenze cookie" nel footer.
        Leggi la <Link to="/cookie-policy" className="underline underline-offset-4 hover:text-gold">Cookie Policy</Link> e la <Link to="/privacy-policy" className="underline underline-offset-4 hover:text-gold">Privacy Policy</Link>.
      </p>
      <div className="flex flex-wrap gap-3 mt-5">
        <button data-testid="cookie-accept" onClick={() => decide("accepted")} className="btn-light !py-3 !px-5">Accetta tutti</button>
        <button data-testid="cookie-reject" onClick={() => decide("rejected")} className="btn-outline-light !py-3 !px-5">Solo necessari</button>
      </div>
    </div>
  );
};
